import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  acceptRepresentativeSettingFailed, acceptRepresentativeSettingSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* acceptRepresentative(action) {
  try {
    if (!action.payload || !action.payload.id) {
      throw new Error('ID not found');
    }
    const url = `${BACKEND_URL}/v1/attorney-powers/${action.payload.id}/approve-user`;
    const response = yield makeRequest(url, action.payload, action, 'POST', true);
    if (response.status === CREATED) {
      yield put(acceptRepresentativeSettingSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(response);
      yield put(acceptRepresentativeSettingFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(acceptRepresentativeSettingFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
